<template>
  <div class="language-select">
    <button @click="changeCulture()">
    <span v-bind:class="{'active' : culture == 'dk'}">Dansk</span>
    <span>/</span>
    <span v-bind:class="{'active': culture == 'en'}">English</span>
    </button>
  </div>
</template>
  
  <script>
  export default {
    data: (instance) => {
      return {
        values: instance.store[instance.store.currentCulture].values,
        d: instance.store[instance.store.currentCulture].dictionary,
        culture: instance.store.currentCulture,
      }
    },
    methods: {
      // updates and emits culture so other components can switch
      changeCulture() {
        this.culture = this.culture == 'dk' ? 'en' : 'dk';
        this.store.currentCulture = this.culture;

        // emitters should only be used for broad scope messaging. We still prefer parent/child component messaging 
        //this.emitter is available on all components and supports .emit (emit event with attached object) .on (listen) and .off (unsubscribe)
        this.emitter.emit('culture-change', this.culture);
      } 
    }
    
  }
  </script>
  <style scoped lang="postcss">
  .language-select {
    position: absolute;
    top: 5px;
    left: 0;
    @media screen and (min-width: 1400px) {
      top: 0;
      left: -250px;
    }
    @media screen and (min-width: 1450px) {
      left: -300px;
    }


    button {
      span {
        font-size: 18px;
        color: var(--color-darkblue);
        margin: 0 5px;
        font-weight: 500;
        @media screen and (min-width: 1024px) {
          font-size: 22px;
        }

        @media screen and (max-width: 1400px) {
          &:first-of-type {
            margin-left: 0;
          }
        }
        &:not(:nth-child(2)) {
          opacity: 0.3;
        }
        &.active {
          opacity: 1;
        }

    }
  }
  }
  </style>